import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyTodosComponent } from './my-todos.component';
import { RouterOutlet } from '@angular/router';
import { CoreModule } from '../../core/core.module';
import { SharedModule } from '../../shared/shared.module';
import { ShivePopupDirective } from '../../core/directives/shive-popup.directive';
import { FeaturesModule } from '../../features/features.module';

@NgModule({
  declarations: [MyTodosComponent],
  imports: [
    CommonModule,
    RouterOutlet,
    CoreModule,
    SharedModule,
    ShivePopupDirective,
    FeaturesModule,
  ],
})
export class MyTodosModule {}
